import React, { useContext } from 'react';
import classNames from 'classnames';
import NavbarDropdown from './NavbarDropdown';
import {
  dashboardRoutes,
  bookingRoutes,
  driveRoutes,
  //socialRoutes,
  crmRoutes,
  // organizationRoutes,
  // authorizationRoutes,
  // jobRoutes,
  // integrationRoutes,
  // settingsRoutes,
  documentationRoutes
} from 'routes/siteMaps';
import { Link } from 'react-router-dom';
import { flatRoutes } from 'helpers/utils';
import NavbarDropdownApp from './NavbarDropdownApp';
import NavbarDropdownPages from './NavbarDropdownPages';
import AppContext from 'context/Context';

const NavbarTopDropDownMenus = () => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig
  } = useContext(AppContext);

  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  // Tailwind replacement for falcon `.dropdown-item` (+ link-600 / text-500)
  const dropdownItemClass = active =>
    classNames(
      'tw-block tw-px-4 tw-py-1.5 tw-text-sm tw-font-medium tw-no-underline hover:tw-bg-[#edf2f9] tw-transition-colors',
      active
        ? 'tw-text-[#748194] hover:tw-text-[#232e3c]'
        : 'tw-text-[#9da9bb] hover:tw-text-[#232e3c]'
    );
  return (
    <>
      <NavbarDropdown title="dashboard">
        {dashboardRoutes.children[0].children.map(route => (
          <Link
            key={route.name}
            className={dropdownItemClass(route.active)}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Link>
        ))}
      </NavbarDropdown>

      <NavbarDropdown title="booking">
        <NavbarDropdownApp items={bookingRoutes.children} />
      </NavbarDropdown>

      <NavbarDropdown title="drive">
        <NavbarDropdownPages items={driveRoutes.children} />
      </NavbarDropdown>
      {/* <NavbarDropdown title="social">
        <NavbarDropdownModules items={socialRoutes.children} />
      </NavbarDropdown> */}

      <NavbarDropdown title="CRM">
        <NavbarDropdownApp items={crmRoutes.children} />
      </NavbarDropdown>

      <NavbarDropdown title="documentation">
        {flatRoutes(documentationRoutes.children).map(route => (
          <Link
            key={route.name}
            className={dropdownItemClass(route.active)}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Link>
        ))}
      </NavbarDropdown>
    </>
  );
};

export default NavbarTopDropDownMenus;
